var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 14.5,
    r: 10.5,
    fill: "#AE6323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8564 17.4316H9.89844L9.49414 8.15039H11.2607L10.8564 17.4316ZM9.31836 20.0859C9.31836 19.6758 9.41797 19.3857 9.61719 19.2158C9.81641 19.04 10.0654 18.9521 10.3643 18.9521C10.6572 18.9521 10.9033 19.04 11.1025 19.2158C11.3076 19.3857 11.4102 19.6758 11.4102 20.0859C11.4102 20.4902 11.3076 20.7861 11.1025 20.9736C10.9033 21.1553 10.6572 21.2461 10.3643 21.2461C10.0654 21.2461 9.81641 21.1553 9.61719 20.9736C9.41797 20.7861 9.31836 20.4902 9.31836 20.0859Z",
    fill: "#F6F3F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.76a19557840e86d35d3c97d7c65a69f6.svg";
export { ForwardRef as ReactComponent };